<template>
  <div class="body-wrap">
    <erp-tree @node-click="nodeClick"></erp-tree>
    <div class="body-main">

      <div class="operation-btns">
        <el-button size="mini" @click="getList()" :loading="searchLoading">查询明细</el-button>
        <el-button size="mini" @click="getCustomerSummary()" :loading="searchLoading">按客户汇总查询</el-button>
        <el-button size="mini" @click="getHouseSummary()" :loading="searchLoading">按房产汇总查询</el-button>

        <el-button size="mini" @click="freeze('freeze', 'select')" :loading="freezeLoading" :disabled="searchLoading">冻结</el-button>
        <el-button size="mini" @click="freeze('freeze', 'all')" :loading="freezeLoading" :disabled="searchLoading">冻结(全部)</el-button>
        <el-button size="mini" @click="freeze('unfreeze', 'select')" :loading="freezeLoading" :disabled="searchLoading">反冻结</el-button>
        <el-button size="mini" @click="freeze('unfreeze', 'all')" :loading="freezeLoading" :disabled="searchLoading">反冻结(全部)</el-button>
        <el-button size="mini" @click="excel()" :loading="searchLoading">导出</el-button>
      </div>

      <!-- 搜索 -->
      <div class="search-wrap" >

        <div class="sw-title">查询条件 <span class="house-name">{{form.house_name}}</span></div>
        <div class="sw-wrap">
          <el-descriptions title="" size="mini" :column="2" border>
            <el-descriptions-item label="收费项目">
              <el-select v-model="form.ChargeItemID" placeholder="请选择" @change="chargeItems" clearable="" size="mini">
                <el-option v-for="item in chargeItemList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="收费标准">
              <el-select v-model="form.ChargeID" placeholder="请选择" size="mini">
                <el-option v-for="item in chargeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-descriptions-item>

            <el-descriptions-item label="客户名称">
              <el-input size="mini" v-model="form.CustomerName" clearable>
                <el-button slot="append" @click="showUserSelector('list')">选择</el-button>
              </el-input>
            </el-descriptions-item>

            <el-descriptions-item label="缴款状态">
              <el-checkbox-group v-model="form.IsPaid">
                <el-checkbox v-for="item in payStatusList" :key="item.value" :label="item.value">{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>

            <el-descriptions-item label="计费周期">
              <el-date-picker size="mini" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="form.BeginEndDate"></el-date-picker>
            </el-descriptions-item>

            <!-- <el-descriptions-item label="是否结帐">
              <el-checkbox-group v-model="form.isClosing">
                <el-checkbox :label="0">未结帐</el-checkbox>
                <el-checkbox :label="1">已结账</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item> -->

            <el-descriptions-item label="应收日期">
              <el-date-picker size="mini" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="form.shouldDate"></el-date-picker>
            </el-descriptions-item>

            <el-descriptions-item label="审核标志">
              <el-checkbox-group v-model="form.isCheck" :disabled="true">
                <el-checkbox :label="0">未审核</el-checkbox>
                <el-checkbox :label="1">已审核</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>

            <!-- <el-descriptions-item label="是否挂账">
              <el-checkbox-group v-model="form.isFrozen" :disabled="true">
                <el-checkbox :label="0">否</el-checkbox>
                <el-checkbox :label="1">是</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item> -->

            <el-descriptions-item label="缴款时间">
              <el-date-picker size="mini" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="form.payDate"></el-date-picker>
            </el-descriptions-item>

            <el-descriptions-item label="生成日期">
              <el-date-picker size="mini" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="form.createDate"></el-date-picker>
            </el-descriptions-item>

            <el-descriptions-item label="是否冻结">
              <el-checkbox-group v-model="form.isChargeFrozen">
                <el-checkbox :label="0">否</el-checkbox>
                <el-checkbox :label="1">是</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>

          </el-descriptions>
        </div>

      </div>
      <div style="margin-top: 5px;"></div>
      <!-- 数据列表 -->
      <div class="table-wrap">
        <el-table v-loading="searchLoading" border height="47vh" :data="tableData" @selection-change="handleSelectionChange" v-if="tableType == 'list'">
          <el-table-column prop="id" type="selection" width="50"></el-table-column>
          <el-table-column prop="h_name" label="客户名称" width="80"></el-table-column>
          <el-table-column prop="h_name_date" label="房产" width="300"></el-table-column>
          <el-table-column prop="charge_name" label="收费标准" width="150"></el-table-column>
          <el-table-column prop="start_end_date" label="计费周期" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.id">{{scope.row.start_date_formatted}}~{{scope.row.end_date_formatted}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="generate_date_formatted" label="审核日期" width="80"></el-table-column>
          <el-table-column prop="should_charge_date_formatted" label="应收日期" width="80"></el-table-column>
          <el-table-column prop="xsc_Amount" label="面积/用量" width="80"></el-table-column>
          <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
          <el-table-column prop="charge_after" label="实际应收金额" width="100"></el-table-column>
          <el-table-column prop="chargePay_after" label="应收金额" width="80"></el-table-column>
          <el-table-column prop="delaySum" label="违约金" width="80"></el-table-column>
          <!-- <el-table-column prop="" label="挂帐金额" width="80"></el-table-column> -->
          <el-table-column prop="" label="是否审核" width="80"></el-table-column>
          <!-- <el-table-column prop="is_closing" label="是否结账" width="80"></el-table-column> -->
          <el-table-column prop="state_text" label="是否缴清" width="80"></el-table-column>
          <!-- <el-table-column prop="" label="是否挂帐" width="80"></el-table-column> -->
          <el-table-column prop="is_frozen_text" label="是否冻结" width="80"></el-table-column>
<!--          <el-table-column prop="id" label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="showDetail(scope.row)" v-if="scope.row.id > 0">查看</el-button>
            </template>
          </el-table-column>-->
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap" v-if="tableType == 'list'">
          <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
        </div>

        <div  v-if="tableType == 'customer-summary'">
          <!-- 按客户汇总查询 -->
          <el-table v-loading="searchLoading" border height="47vh" :data="customerSummary.list">
            <el-table-column v-for="(item, index) in customerSummary.head" :formatter="valueFormatter" :key="index" :prop="item.key" :label="item.name"></el-table-column>
            <!-- <el-table-column v-for="(item, index) in customerSummary.head" :key="index" :prop="item.key" :label="item.name"></el-table-column> -->
          </el-table>
          <!-- 分页 -->
          <div class="pagination-wrap">
            <el-pagination background layout="total, prev, pager, next" :total="customerSummary.total" :page-size="customerSummary.pageSize" :current-page="customerSummary.page" @current-change="pageChange2"></el-pagination>
          </div>
        </div>

        <div  v-if="tableType == 'house-summary'">
          <!-- 按房产汇总查询 -->
         <el-table v-loading="searchLoading" border height="47vh" :data="houseSummary.list">
            <el-table-column v-for="(item, index) in houseSummary.head" v-if="index==0" width="300" :formatter="valueFormatter" :key="index" :prop="item.key" :label="item.name">
              <el-table-column v-for="(child, index) in item.children" :formatter="valueFormatter" :key="child.key" :prop="child.key" :label="child.name"></el-table-column>
            </el-table-column>

            <el-table-column v-for="(item, index) in houseSummary.head" v-if="index>0" :formatter="valueFormatter" :key="index" :prop="item.key" :label="item.name">
              <el-table-column v-for="(child, index) in item.children" :formatter="valueFormatter" :key="child.key" :prop="child.key" :label="child.name"></el-table-column>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination-wrap">
            <el-pagination background layout="total, prev, pager, next" :total="houseSummary.total" :page-size="houseSummary.pageSize" :current-page="houseSummary.page" @current-change="pageChange3"></el-pagination>
          </div>
        </div>
      </div>


<!--      <el-dialog title="应收款明细" :visible.sync="editDialogVisible" class="edit-dialog" width="800px">
        <el-button size="mini" style="margin-bottom: 10px;" @click="showChangeDetail()">变动明细</el-button>

        <el-descriptions title="" size="mini" :column="2" border>
          <el-descriptions-item label="房产">
            <el-input size="mini" v-model="editForm.house_name">
              <el-button slot="append" @click="houseDialogVisible = true">选择</el-button>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="客户名称">
            &lt;!&ndash; <el-autocomplete size="mini" placeholder="请输入关键字搜索" clearable v-model="editForm.h_name" :trigger-on-focus="false" :fetch-suggestions="queryCustomer" @select="editSelectCustomer" style="max-width: 200px;"></el-autocomplete> &ndash;&gt;
            <el-input size="mini" v-model="editForm.h_name">
              <el-button slot="append" @click="showUserSelector('edit')">选择</el-button>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="联系人">
            <el-input size="mini" v-model="editForm.contact" disabled></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            <el-input size="mini" v-model="editForm.contact_number" disabled></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="收费项目">
            <el-input size="mini" v-model="editForm.charge_item_name" disabled></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="收费标准">
            <el-input size="mini" v-model="editForm.charge_name" disabled></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="应收日期">
            <el-date-picker size="mini" v-model="editForm.should_charge_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="计划周期">
            <el-date-picker size="mini" v-model="editForm.start_end_date" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="单价">
            <el-input size="mini" v-model="editForm.price" class="price" disabled></el-input>
          </el-descriptions-item>
          <el-descriptions-item label=""></el-descriptions-item>
          <el-descriptions-item label="金额">
            <el-input size="mini" v-model="editForm.charge_pay" class="charge-price" @change="changePrice()"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label=""></el-descriptions-item>
          <el-descriptions-item label="已缴金额">
            <el-input size="mini" v-model="editForm.paid_charge_sum" disabled></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="挂帐金额"></el-descriptions-item>
          <el-descriptions-item label="减免类型">
            <el-select v-model="editForm.discountType" placeholder="请选择" size="mini">
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="减免金额">
            <el-input size="mini" v-model="editForm.discount" class="discount" @change="changePrice()"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="应收金额">
            <el-input size="mini" v-model="editForm.charge" class="charge"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label=""></el-descriptions-item>
          <el-descriptions-item label="备注">
            <el-input size="mini" v-model="editForm.remark"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="事务单号"></el-descriptions-item>
        </el-descriptions>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveDetail" v-if="editForm.state != 2">保 存</el-button>
          <el-button @click="editDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

      <el-dialog title="选择房产" :visible.sync="houseDialogVisible" :close-on-click-modal="true" class="edit-dialog" width="500px">
        <erp-tree @node-click="nodeClick2"></erp-tree>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveDetail2">保 存</el-button>
            <el-button @click="houseDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

      &lt;!&ndash; 弹窗选择用户 &ndash;&gt;
      <el-dialog title="选择客户" top="5vh" :visible.sync="userSelectorVisible" :close-on-click-modal="true" class="business-dialog" width="800px">
        <div>
          <room-user style="height: 600px;" ref="roomUser" :house="shouse"></room-user>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="roomUserSelect" >确 定</el-button>
          <el-button @click="userSelectorVisible = false">取 消</el-button>
        </div>
      </el-dialog>

      &lt;!&ndash; 违约金计算 &ndash;&gt;
      <el-dialog title="变动明细" top="5vh" :visible.sync="changeDetailVisible" :close-on-click-modal="true" width="1000px">
        <el-table :data="changeDetailData" v-loading="changeDetailLoading" height="250" border style="width: 100%">
          <el-table-column prop="h_name_date" label="房产"></el-table-column>
          <el-table-column prop="h_name" label="客户"></el-table-column>
          <el-table-column prop="should_charge_date_formatted" label="应收日期"></el-table-column>
          <el-table-column prop="start_end_date" label="计费周期">
            <template slot-scope="scope">
              <span>{{scope.row.start_date_formatted}} ~ {{scope.row.end_date_formatted}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="chargePay" label="金额"></el-table-column>
          <el-table-column prop="discount" label="折扣"></el-table-column>
          <el-table-column prop="charge" label="应收金额"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column prop="admin_name" label="操作员"></el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button @click="changeDetailVisible = false">关 闭</el-button>
        </div>
      </el-dialog>-->

    </div>


  </div>
</template>
<script>
import ErpProject from "../Common/erp-project";
import ErpTree from "../Common/erp-tree.vue";
import RoomUser from '../Common/room-user.vue';
export default {
  name: 'area-tax',
  components: {ErpProject, RoomUser, ErpTree},
  data () {
    return {
      total: 0,
      tableData: [],
      keyword: '',
      page: 1,
      pageSize: 10,
      searchLoading: false,
      totalInfo: {},
      tableType: 'list',
      selectItem: [],
      form: {
        pindex_id: '',
        house_name: '',
        ChargeItemID: '',
        ChargeID: '',
        CustomerName: '',
        IsPaid: [],
        BeginEndDate: [],
        isClosing: [],
        shouldDate: [this.getFirstDay(), this.dateFormat()],
        isCheck: [1],
        isFrozen: [],
        payDate: [],
        createDate: [],
        isChargeFrozen: []
      },
      chargeItemList: [],
      chargeList: [],
      payStatusList: [{label: '未缴款', value: 0}, {label: '部分缴款', value: 1}, {label: '已缴款', value: 2}],
      editDialogVisible: false,
      editDialogLoading: false,
      editForm: {
        id: '',
        pindex_id: '',
        house_id: '',
        house_name: '',
        charge_item_name: '',
        h_name: '',
        h_name_idid: '',
        charge_name: '',
        should_charge_date: '',
        start_end_date: [],
        price: '',
        charge_pay: '',
        paid_charge_sum: '',
        discountType: '',
        discount: '',
        charge: '',
        remark: '',
      },
      selectedItemList: [],
      houseDialogVisible: false,
      houseSelectItem: '',
      userSelectorType: '',
      userSelectorVisible: false,
      shouse: '',
      customerSummary: {
        data: [],
        head: [],
        list: [],
        page: 1,
        pageSize: 10,
        total: 0,
      },
      houseSummary: {
        data: [],
        head: [],
        list: [],
        page: 1,
        pageSize: 10,
        total: 0,
      },
      freezeLoading: false,
      changeDetailVisible: false,
      changeDetailData: [],
      changeDetailLoading: false,
    }
  },
  mounted() {
    this.getChargeItemList()
  },
  watch: {
    "form.HouseID": function(val) {
      this.getChargeList()
    },
    // "form.ChargeItemID": function(val) {
    //   this.getChargeList()
    // },
  },
  methods: {
    nodeClick(d) {
      this.form.house_name = d.tree.map(item => item.name).join('->')
      if(this.form.ChargeItemID) {
        this.getChargeList()
      }
      this.getChargeItemList();
      switch(this.tableType) {
        case 'list': this.getList(); break;
        case 'customer-summary': this.getCustomerSummary(); break;
        case 'house-summary': this.getHouseSummary(); break;
      }
    },

    getChargeItemList() {
      this.$myhttp.get('admin/getChargeItemList?house_name='+this.form.house_name).then(res => {
        this.chargeItemList = res.data.code == 200 ? res.data.data.map(item => {return {value: item.id, label: item.chargeItem_name}}) : []
      })
    },

    handleSelectionChange(data) {
      this.selectItem = data
    },

    //查询
    getList() {
      if(this.form.house_name == ''){
        this.$message.warning('房产不能为空，请点击左边树');
        return false;
      }
      this.tableType = 'list'
      let params = Object.assign({page: this.page, page_size: this.page_size}, this.form)
      this.searchLoading = true
      this.$myhttp.get('admin/queryChargeOrder', {params: params}).then(resp => {
        let res = resp.data
        this.searchLoading = false
        if(resp.data.code == 200){
          this.tableData = res.data
          this.total = res.total
          if(res.total > 0) {
            res.data.push({
              id: 0,
              h_name: '合计',
              charge_after: res.summary_page.charge_after.toFixed(2),
              chargePay_after: res.summary_page.chargePay_after.toFixed(2),
            })
            res.data.push({
              id: 0,
              h_name: '总合计',
              charge_after: res.summary_total.charge_after.toFixed(2),
              chargePay_after: res.summary_total.chargePay_after.toFixed(2),
            })
          }
        }else{
          this.$message.warning(resp.data.message);
        }
      })
    },

    //导出
    excel(){
      if(this.form.house_name == ''){
        this.$message.warning('房产不能为空，请点击左边树');
        return false;
      }
      this.tableType = 'list'
      let params = Object.assign({page: this.page, page_size: this.page_size}, this.form)
      this.searchLoading = true
      this.$myhttp.get('admin/chargeQueryExcel', {params: params}).then(resp => {
        this.searchLoading = false;
        let data = resp.data.data;
        if(resp.data.code == 200){
          let url = this.$myhttp.defaults.baseURL;
          window.open(url+data, '_blank');
        }else{
          this.$Message.error(resp.data.message);
        }
      })
    },

    getChargeItemName(id) {
      for(let k in this.chargeItemList) {
        if(this.chargeItemList[k].value == id) return this.chargeItemList[k].label
      }
      return ''
    },

    pageChange(data) {
      this.page = data
      this.getList()
    },
    chargeItems(){
      this.getChargeList();
    },
    getChargeList() {
      //if(this.form.pindex_id == '' || this.form.ChargeItemID == '') return false
      this.form.ChargeID = ''
      let params = {
        pindex_id: this.form.pindex_id,
        chargeItem_name_id: this.form.ChargeItemID,
        house_name:this.form.house_name
      }
      this.$myhttp.get('admin/getHouseCharge', {params: params}).then(resp => {
        let res = resp.data
        if(res.code == 200) {
          this.chargeList = res.data.map(item => {return {label: item.name + item.charge, value: item.id, charge: item.charge}})
        } else {
          this.chargeList = []
        }

        this.chargeList.unshift({label: '请选择...', value: ''})
      })
    },

    queryCustomer(val, callback) {

      this.$myhttp.get('admin/getCustomerName', {params: {text: val}}).then(res => {
        callback(res.data.code == 200 ? res.data.data.map(item => {return {id: item.id, value: item.name}}) : []);
      })

    },

    showDetail(data) {

      console.log(data)

      this.editForm = Object.assign(this.editForm, {
        id                  : data.id,
        pindex_id           : data.pindex_id,
        house_id            : data.house_id,
        house_name          : data.h_name_date,
        h_name              : data.h_name,
        h_name_idid         : data.h_name_idid,
        charge_item_name    : this.getChargeItemName(data.xsc_ChargeItemID_id),
        charge_name         : data.charge_name,
        should_charge_date  : data.should_charge_date_formatted,
        start_end_date      : [data.start_date_formatted, data.end_date_formatted],
        price               : data.xsc_Price,
        charge_pay          : data.chargePay,
        paid_charge_sum     : data.PaidChargeSum,
        discount            : data.discount,
        charge              : data.charge,
        remark              : data.remark,
        state               : data.state,
      })

      this.$myhttp.get('admin/getCustomerPhone', {params: {id: data.customer_id}}).then(resp => {
        let res = resp.data
        if(res.code == 200) this.editForm.contact_number = res.data
      })

      this.editDialogVisible = true
    },

    saveDetail() {

      console.log(this.editForm)

      this.$myhttp.post('admin/saveChargeOrder', Object.assign({}, this.editForm)).then(resp => {
        let res = resp.data
        this.message(res)
        if(res.code == 200) {
          this.editDialogVisible = false
          this.getList()
        }

      })

    },

    changePrice() {

      this.editForm.charge = this.editForm.charge_pay - this.editForm.discount

    },

    nodeClick2(d) {
      console.log(d)
      this.houseSelectItem = d
    },

    saveDetail2() {

      if(this.houseSelectItem.type != 'room') {
        this.$message.warning('请选择房间')
        return false
      }

      let house_name = []
      this.houseSelectItem.tree.forEach(item => {
        house_name.push(item.name)
      })
      this.editForm.house_name = house_name.join('->')
      this.editForm.house_id = this.houseSelectItem.id

      this.houseDialogVisible = false
    },

    roomUserSelect() {
      let user = this.$refs.roomUser.getUser();
      if(this.userSelectorType == 'list') {
        this.form.CustomerName = user.name
      } else {
        this.editForm.h_name = user.name
        this.editForm.h_name_idid = user.credentials_code.replace("\t", '')

      }

      this.userSelectorVisible = false
    },

    showUserSelector(type) {
      this.userSelectorType = type
      this.userSelectorVisible = true
    },

    message(res) {
      this.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
    },

    getTimestamp() {
    	return Math.floor(new Date().getTime() / 1000)
    },

    dateFormat(timestamp = 0) {
    	let date = timestamp > 0 ? new Date(timestamp * 1000) : new Date();
    	let year = date.getFullYear();
    	let month = ("0" + (date.getMonth() + 1)).slice(-2);
    	let sdate = ("0" + date.getDate()).slice(-2);
    	let result = year + "-" + month + "-" + sdate;
    	return result
    },

    getFirstDay() {
    	let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      if(month < 10) month = '0' + month
      return [year, month, '01'].join('-')
    },
    //按客户查询
    getCustomerSummary() {
      if(this.form.house_name == ''){
        this.$message.warning('房产不能为空，请点击左边树');
        return false;
      }
      this.tableType = 'customer-summary'
      let params = Object.assign({}, this.form)
      this.searchLoading = true
      this.$myhttp.get('admin/getCustomerSummary', {params: params}).then(resp => {
        this.searchLoading = false
        let res = resp.data
        let head = []
        head.push({key: 'name', name: res.head['name']})
        for(let k in res.head) {
          if(['name', 'sub_total'].includes(k) == false) head.push({key: k, name: res.head[k]})
        }
        head.push({key: 'sub_total', name: res.head['sub_total']})
        this.customerSummary.head = head
        this.customerSummary.data = res.list
        this.customerSummary.page = 1
        this.customerSummary.total = res.list.length
        this.pageChange2(1)
      })
    },

    valueFormatter(row, column, cellValue, index) {
      return cellValue || 0
    },

    pageChange2(page) {
      this.customerSummary.page = page
      let start = (page-1) * this.customerSummary.pageSize
      this.customerSummary.list = this.customerSummary.data.slice(start, start + this.customerSummary.pageSize)
    },

    getHouseSummary() {
      if(this.form.house_name == ''){
        this.$message.warning('房产不能为空，请点击左边树');
        return false;
      }
      let params = Object.assign({}, this.form)
      this.tableType = 'house-summary'
      this.searchLoading = true
      this.$myhttp.get('admin/getHouseSummary', {params: params}).then(resp => {
        this.searchLoading = false
        let res = resp.data

        this.houseSummary.head = res.head
        this.houseSummary.data = res.list
        this.houseSummary.page = 1
        this.houseSummary.total = res.list.length
        this.pageChange3(1)
      })
    },

    pageChange3(page) {
      this.houseSummary.page = page
      let start = (page-1) * this.houseSummary.pageSize
      this.houseSummary.list = this.houseSummary.data.slice(start, start + this.houseSummary.pageSize)
    },

    /**
     * @param {Object} operation    freeze冻结，unfreeze反冻结
     * @param {Object} selection    select选中，all全部
     */
    freeze(operation, selection) {

      let params = {
        operation: operation,
        selection: selection,
      }

      if(selection == 'select') {

        if(this.selectItem.length == 0) {
          this.$message.warning('请选择应收款记录!')
          return false
        }

        params.ids = this.selectItem.map(item => item.id).join(',')
        this.freezeAction(params)

      } else {

        this.$confirm('确认将所选条件下的记录全部'+(operation == 'freeze' ? '冻结' : '反冻结')+'吗？', '提示', {type: 'warning'}).then(() => {

          params = Object.assign(params, this.form)
          this.freezeAction(params)

        })

      }

    },

    freezeAction(params) {
      this.freezeLoading = true
      params.house = this.form.house_name;
      this.$myhttp.get('admin/freezeChargeOrder', {params: params}).then(resp => {
        let res = resp.data
        this.message(res)
        if(res.code == 200) {
          this.getList()
        }

        this.freezeLoading = false

      })

    },

    showChangeDetail() {

      this.changeDetailLoading = true
      this.$myhttp.get('admin/getChangeDetail', {params: {order_id: this.editForm.id}}).then(resp => {

        let res = resp.data
        if(res.code == 200) {
          this.changeDetailData = res.data
        }

        this.changeDetailLoading = false

      })

      this.changeDetailVisible = true

    }

  },

}
</script>
<style lang="scss" scoped>

  @import '../Project/common.scss';

  // .table-wrap,.search-wrap {
  //   max-width: 1000px;
  // }

  .el-button--small {
    padding: 7px 10px;
  }

  /deep/.el-input-group .el-input-group__append {
    padding: 0 15px;
  }

  /deep/.readonly .el-input__inner {
    background-color: #eee;
  }

  /deep/ .search-wrap {
    .el-radio,.el-checkbox {
      margin-right: 20px;
    }
  }

  /deep/ .edit-dialog {
    .discount .el-input__inner {
      color: #5500ff;
      text-align: right;
      font-weight: bold;
    }

    .price {
      text-align: right;
    }

    .charge-price .el-input__inner {
      color: #000000;
      text-align: right;
      font-weight: bold;
    }

    .charge .el-input__inner {
      color: #ff5500;
      text-align: right;
      font-weight: bold;
    }

    .tree-wrap {
      width: 100%;
    }

    .el-tree-1 {
      height: 350px;
    }
  }

  .body-wrap {
    display: flex;

    .body-main {
      flex: 1;
      margin-left: 15px;
      width: calc(100% - 250px)
    }

    .search-wrap {
      width: 100%;
      border: 1px solid #EBEEF5;
      flex-direction: column;

      .sw-title {
        margin: 0;
        font-size: 12px;
        color: #909399;
        background: #fafafa;
        padding: 5px;
        border-bottom: 1px solid #EBEEF5;

        .house-name {
          margin-left: 20px;
        }
      }

      .sw-wrap {
        padding: 10px;


      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/chargeQuery.vue